import { Columns } from "./columns";
import { Filters } from "./filters";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const PodProductionReportConfig: ReportConfigBase = {
  type: EReportTypes.PodProduction,
  endpoint: "report/pod-production",
  filtersBase: Filters,
  summaryBase: null,
  columnsBase: Columns,
  withSelection: true,
  intro: {
    description: "Checkouts from your print on demand shops",
    url: "https://help.commonsku.com/knowledge/",
  },
};

export default PodProductionReportConfig;
